//@flow
// auth services
import { decamelizeKeys } from 'humps';

import api from '../lib/api';
import endpoints from '../lib/endpoints';
import type { classicCredentials, oauthCredentials } from '../types/auth';

type Credentials = classicCredentials | oauthCredentials;

type ActionObject = { type: string, credentials: Credentials };

const authenticate = (action: ActionObject) => {
  const url = chooseEndPoint(action);
  const data = decamelizeKeys(makeCredentials(action));
  return api.postWithoutToken(url, data);
};

const masquerade = (id: string) => {
  const url = endpoints.admin.masquerade(id);
  return api.getWithToken(url);
};

/**
 * @param  {string}      type => action.tyoe
 * @return {Object}      credentials
 *                            email and password if via email or "google" or "facebook" as type if from social media
 *
 * @return {Object}       signup api doesn`t require any object wrapped around it while login via email requires classic wrapper
 *                        while social media login requires oauth wrapper.
 */

const makeCredentials = action =>
  isRegister(action)
    ? { ...action.credentials }
    : makeCredentialsForLogin(action.credentials);

const makeCredentialsForLogin = (credentials: Credentials) =>
  credentials.provider ? { oauth: { ...credentials } } : { classic: { ...credentials } };

const isRegister = action =>
  action.type.includes('register') && !action.credentials.provider;

const chooseEndPoint = action =>
  isRegister(action) ? endpoints.auth.signup : endpoints.auth.login;

const registerNewUser = action =>
  api.postWithoutToken(endpoints.auth.signup, decamelizeKeys(makeCredentials(action)));

export default authenticate;
export { masquerade, registerNewUser };



// WEBPACK FOOTER //
// ./src/services/auth.js